import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Redirect, Switch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { fetchGetMe, fetchTermIsAccepted } from './store/auth/authSlice';
import Page from './components/Page';
import Home from './views/Home';
import Terms from './views/Terms';
import ApplicationCreate from './views/ApplicationCreate';
import Applications from './views/Applications';
import ApplicationView from './views/ApplicationView';
import ApplicationQuestionnaires from './views/ApplicationQuestionnaires';
import QuestionnaireDetail from './views/QuestionnaireDetail';
import { RootState } from './store/rootReducer';

interface Props {
  url: string;
}

const PrivateRouter: React.FC<Props> = ({ url }: Props) => {
  const { t } = useTranslation(['common']);
  const dispatch = useDispatch();
  const termIsAccepted = useSelector((state: RootState) => state.auth.termIsAccepted);
  const termIsAcceptedValue = useSelector((state: RootState) => state.auth.termIsAcceptedValue);
  const termIsAcceptedError = useSelector((state: RootState) => state.auth.termIsAcceptedError);

  useEffect(() => {
    dispatch(fetchTermIsAccepted());

    const interval = setInterval((): void => {
      dispatch(fetchGetMe());
    }, 150000);

    return (): void => clearInterval(interval);
  }, [dispatch]);

  if (termIsAccepted == null) {
    return null;
  }

  if (!termIsAcceptedValue) {
    return (
      <Switch>
        <Route path="/skilmalar" component={Terms} exact />
        <Redirect to="/skilmalar" />
      </Switch>
    );
  }

  if (termIsAcceptedError != null) {
    return <p>{t('kerfisvilla')}</p>;
  }

  return (
    <>
      <Page>
        <Switch>
          <Redirect from="/skilmalar" to="/" exact />
          <Route path="/" component={Home} exact />
          <Route path="/skoda-skilmala" component={Terms} exact />
          <Route path="/umsokn" component={ApplicationCreate} exact />
          <Route path="/umsoknir" component={Applications} exact />
          <Route path="/matslistar" component={ApplicationQuestionnaires} exact />
          <Route path="/matslisti/:id" component={QuestionnaireDetail} exact />
          <Route path="/skoda-umsokn/:id" component={ApplicationView} exact />
        </Switch>
      </Page>
    </>
  );
};

export default PrivateRouter;
